/* eslint-disable react-hooks/exhaustive-deps */
import {google_client_id, redirect_URL} from 'config';
import _ from 'lodash';
import {memo, useEffect, useState} from 'react';
import GoogleOneTapLogin from 'react-google-one-tap-login';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {connect, useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';

import successMessages from 'utils/successMessages';
import {googleOneTabLogin} from 'views/components/socialLogin.component';
import appraisalHeaderImg from '../assets/img/appraisal-bg-new.png';
import {estibotApprasisal, getAppraisalAllowance, recentlySearchedAppraisal} from '../store/actions/appraisal.action';
import * as types from '../store/actions/types';
import {sendAppraisalCertificate} from '../store/actions/user.action';
import {RootState} from '../store/reducers';
import {scheduleAppraisalAllowanceRefresh} from './appraisalAllowanceReset';
import errorMessages from '../utils/errorMessages';
import {CheckAccess, buyNewDomain, capitalizeFirstLetter, createAccount, decryptData, getLocalStorageValue, handleToast, historyPath, historyPush, isUserLoggedIn, isUserRole, isValidDomainName, loadBasicAPIs, localStorageKeyValue, navigateUserLogin, previousActionConfigs, removeLocalStorageValue, setLocalStorageValue, userInterested} from '../utils/handler';
import {AppraisalLoading} from './appraisalLoading';
import {AppraisalDashboard} from './dashboard';
import EmailModal from './emailModal';
import {AppraisalResult} from './result';
let referrerURL = document.referrer;
// if (referrerURL && referrerURL.includes(redirect_URL)) {
//   console.log("@@@@@@@@@@@@@@")
//   referrerURL = ""
// }
console.log(referrerURL, 'referrer-url', redirect_URL);

let buyDomainType = '';
let buyDomainName = '';
let buyOfferAmount = '';
let globalDomainName = '';
export const Appraisal: React.FC = memo((): JSX.Element => {
  const [domainName, setDomainName] = useState<string>('');
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [domainNameValidationError, setDomainNameValidationError] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  // const [currentTime, setCurrentTime] = useState(moment());
  // const [timer, setTimer] = useState({hours: 24, minute: 60});
  const { previousAction = '', searchedDomain = '', showVerificationCodeWindow = false, showLoginWindow = false } = useSelector((state: RootState) => state.mainReducer);
  const { appraisalDetails, appraisalError = '' } = useSelector((state: RootState) => state.appraisalReducer);
  const {appraisalAllowance, appraisalAllowanceError, appraisalAllowanceLoading, appraisalSearchHistory = []} = useSelector((state: RootState) => state.appraisalReducer);
  const { myProfile } = useSelector((state: RootState) => state.userReducer);
  // const [email, setEmail] = useState<string>('');
  // const [userName, setUserName] = useState<string>('');
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showMailModal, setShowMailModal] = useState<boolean>(false);
  const appraisalCount = appraisalAllowance.limit;
  const appraisalRemainingCount = appraisalAllowance.remaining;
  const appraisalUnLimited = appraisalAllowance.unlimited;
  // const [appraisalTodayCount, setAppraisalTodayCount] = useState<number>(0);

  // const handleCredentialResponse = (data: any) => {
  //   console.log(data)
  // }
  // window.google.accounts.id.initialize({
  //   client_id: google_client_id,
  //   callback: data => console.log(data),
  //   // state_cookie_domain: 'https://example.com'
  // });

  // useGoogleOneTapLogin({
  //   onError: error => console.log(error),
  //   onSuccess: response => googleOneTabLogin(response),
  //   googleAccountConfigs: {
  //     client_id: google_client_id
  //   }
  // });

  useEffect(() => {
    // console.log(previousAction, showLoginWindow, showVerificationCodeWindow, buyDomainName)
    if (!showLoginWindow && !showVerificationCodeWindow && previousAction) {
      if (previousAction === 'sendAppraisalToMail') sendAppraisalToMail(globalDomainName);
      if (previousAction === 'handleSubmit') handleSubmit();
      if (previousAction === 'buyDomain') buyDomain(buyDomainType, buyDomainName, buyOfferAmount);
    }
  }, [previousAction, showLoginWindow, showVerificationCodeWindow]);

  useEffect(() => {
    let decrypt = decryptData(searchedDomain);
    handleSubmit(decrypt);
  }, [searchedDomain]);

  useEffect(() => {
    loadBasicAPIs();
    const params = new URLSearchParams(history.location.search);
    let domainName = params.get('domainName');
    const token = params.get('token');
    if (domainName && token) {
      let decrypt = decryptData(domainName);
      handleSubmit(decrypt, token);
      // history.replace({
      //   search: ""
      // })
    }
    domainName = getLocalStorageValue(localStorageKeyValue.domainName);
    if (domainName) {
      removeLocalStorageValue(localStorageKeyValue.domainName);
      // setDomainName(domainName);
    }
  }, []);
  // useEffect(() => {
  //   console.log('appraisalLimit', appraisalLimit)
  //   let domainName = getLocalStorageValue(localStorageKeyValue.domainName)
  //   if (domainName)
  //     handleSubmit(domainName)
  // }, [appraisalLimit])

  useEffect(() => {
    recentlySearchedAppraisal();
    getAppraisalAllowance();
  }, [myProfile]);

  useEffect(() => {
    const resetTimer = scheduleAppraisalAllowanceRefresh(
      appraisalAllowance.resetAt,
      getAppraisalAllowance,
      Date.now(),
      (callback, delay) => window.setTimeout(callback, delay),
    );
    if (resetTimer == null) return;
    return () => window.clearTimeout(resetTimer);
  }, [appraisalAllowance.resetAt]);

  const handleSubmit = async (domain: string = '', token: string = '') => {
    domain = domain || domainName;
    domain = domain.trim();
    if (appraisalDetails && appraisalDetails.domain === domain) {
      return true;
    }
    if (domain) {
      let canAppraise = Boolean(
        appraisalAllowanceError ||
          appraisalAllowanceLoading ||
          appraisalRemainingCount ||
          appraisalUnLimited,
      );
      if (!canAppraise) {
        const domainAllowance = await getAppraisalAllowance(domain);
        canAppraise = domainAllowance
          ? Boolean(domainAllowance.canAppraise)
          : true;
      }
      if (canAppraise) {
        if (isValidDomainName(domain)) {
          // setDomainName(domain);
          setShowLoader(true);
          estibotApprasisal(domain, token).then((res) => {
            setShowLoader(false);
            setDomainName('');
          });
        }
      } else {
        if (!isUserLoggedIn()) {
          // setDomainName(domain);
          createAccount(types.SHOW_UPGRADE_WINDOW, previousActionConfigs.handleSubmit);
        }
        handleToast({ message: errorMessages.reachedAppraisalLimit });
      }
    }
  };
  const buyDomain = (type: string = userInterested.buy, domain: string = appraisalDetails.domain || getLocalStorageValue(localStorageKeyValue.domainName), offerAmount = appraisalDetails.saw_appraised_value || getLocalStorageValue(localStorageKeyValue.offerAmount)) => {
    setLocalStorageValue(localStorageKeyValue.domainName, domain);
    setLocalStorageValue(localStorageKeyValue.offerAmount, offerAmount);
    setLocalStorageValue(localStorageKeyValue.interestIn, type);
    if (isUserLoggedIn()) {
      if (isUserRole()) {
        dispatch({ type: types.SET_DOMAIN_NAME, payload: domain });
        dispatch({ type: types.PREVIOUS_ACTION, payload: previousAction.buyDomain });
        dispatch({ type: types.SET_DOMAIN_OFFER_AMOUNT, payload: offerAmount.toString() });
        navigateUserLogin(domain, offerAmount.toString());
        buyNewDomain();
      } else {
        historyPush(historyPath.dashboard);
      }
    } else {
      buyDomainName = domain;
      buyDomainType = type;
      buyOfferAmount = offerAmount.toString();
      if (buyDomainName) {
        dispatch({ type: types.PREVIOUS_ACTION, payload: 'buyDomain' });
      }
      dispatch({ type: types.SHOW_UPGRADE_WINDOW, payload: true });
    }
  };
  const updateAppraisalCertificateLoader = (domain: string, value: boolean) => {
    const domainAppraisal = [...appraisalSearchHistory];
    let domainIndex = _.findIndex(domainAppraisal, { domain });
    if (domainAppraisal && domainAppraisal[domainIndex]) {
      domainAppraisal[domainIndex].downloadingCertificate = value;
    }
    dispatch({ type: types.APPRAISAL_SEARCH_HISTORY, payload: domainAppraisal });
  };
  const sendAppraisalToMail = (domain: string) => {
    // setDomainName(domain);
    domain = domain || domainName;
    globalDomainName = domain;
    if (isUserLoggedIn()) {
      if (CheckAccess('EmailAppraisalCertificate')) {
        updateAppraisalCertificateLoader(domain, true);
        sendAppraisalCertificate({ domainName: domain, email: myProfile.email }).then((emailResponse) => {
          if (emailResponse) {
            handleToast({ message: successMessages.appraisalSent }, 'success');
          }
          updateAppraisalCertificateLoader(domain, false);
        });
      } else {
        handleToast({ message: errorMessages.notAllowed });
      }
    } else {
      globalDomainName = domain;
      setShowMailModal(true);
      // dispatch({ type: types.PREVIOUS_ACTION, payload: 'sendAppraisalToMail' });
      // dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
      // updateAppraisalCertificateLoader(domain, false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDomainName(e.target.value);
    setFormSubmitted(false);
    if (isValidDomainName(e.target.value)) {
      setDomainNameValidationError(false);
    } else {
      setDomainNameValidationError(true);
    }
  };

  const signUp = () => {
    // if (domainName)
    //   setLocalStorageValue(localStorageKeyValue.domainName, domainName);
    createAccount(types.SHOW_UPGRADE_WINDOW, 'Appraisal');
    // dispatch({type: types.PREVIOUS_ACTION, payload: "Appraisal"});
    // dispatch({type: types.SHOW_LOGIN_WINDOW, payload: true});
    // dispatch({type: types.SHOW_SIGNUP_WINDOW, payload: true});
    // dispatch({type: types.SHOW_UPGRADE_WINDOW, payload: true})
  };
  const getCount = () => {
    return appraisalAllowanceLoading ? <i className="fas fa-circle-notch fa-spin fa-speed-3"></i> : appraisalRemainingCount;
  };
  const remainingContent = () => {
    return (
      <span>
        {' '}
        {appraisalRemainingCount > 0 && appraisalRemainingCount !== appraisalCount ? <span>Just</span> : null}
        <span className="f-bold ml-1 mr-1">
          {getCount()} domain appraisal{appraisalRemainingCount <= 1 ? '' : 's'}
        </span>{' '}
        remaining today!
      </span>
    );
  };
  return (
    <>
      <Helmet>
        <title>Free Domain Appraisal Tool - Accurate Results Instantly</title>
      </Helmet>
      {isUserLoggedIn() ? null : <GoogleOneTapLogin onError={(error) => console.log(error)} onSuccess={(response) => googleOneTabLogin(response)} googleAccountConfigs={{ client_id: google_client_id }} />}
      {showMailModal && <EmailModal closePopup={() => setShowMailModal(false)} domain={domainName || globalDomainName} />}
      {showLoader ? (
        <AppraisalLoading />
      ) : (
        <>
          <div className={'text-center ash-bg overflow-hide ' + (_.isEmpty(appraisalDetails) ? ' pb-50 ' : ' pb-125 ')}>
            <div className=" container   ">
              <img alt="" className="header-db-img-center" src={appraisalHeaderImg}></img>
              {!_.isEmpty(appraisalDetails) ? (
                <div className="position-relative main-text">Need to get value for another domain? </div>
              ) : (
                <>
                  <div className="main-text">Welcome To Your Saw.com Appraisal Tool{myProfile.name ? ', ' + capitalizeFirstLetter(myProfile.name.split(' ')[0]) : ''}</div>
                  {appraisalUnLimited ? null : (
                    <div className="fs-25 mt-2">
                      You can appraise {appraisalCount} domain{appraisalCount <= 1 ? '' : 's'} per day here…
                    </div>
                  )}
                </>
              )}

              <div className="d-flex justify-content-center">
                <form
                  className="g-recaptcha col-lg-7 col-md-10 mt-3"
                  noValidate
                  onSubmit={(e: React.FormEvent) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  <div className="input-group form-group ">
                    <input placeholder={t('Enter a domain name')} autoComplete="off" type="text" name="domainName" value={domainName} onChange={(e) => handleChange(e)} className="form-control " required />
                    <button
                      type="submit"
                      className=" g-recaptcha btn-grad btn normal-btn pl-4 pr-4"
                      onSubmit={(e: React.FormEvent) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      get value
                    </button>
                    <div className="invalid-feedback">{t('Please Enter Domain name')}</div>
                  </div>
                  {formSubmitted && domainNameValidationError && <div className="text-danger d-flex appraisal-error-message">{errorMessages.domainWithoutExtension}</div>}
                </form>
              </div>

              {appraisalUnLimited ? null : !_.isEmpty(appraisalDetails) ? (
                <div className="row justify-content-center align-items-center position-relative create-free-account-appraisal">
                  {_.isEmpty(myProfile) ? (
                    <span>
                      You can appraise up to {appraisalCount} domain{appraisalCount > 1 ? 's' : ''} per day with this appraisal tool. To raise your limit and get more detailed domain information,
                      <span className="theme-color underline c-pointer " onClick={signUp}>
                        {' '}
                        create a free account
                      </span>{' '}
                      with us.
                    </span>
                  ) : appraisalRemainingCount === 0 ? (
                    <span>{errorMessages.reachedAppraisalLimit}</span>
                  ) : (
                    <div className=" row d-flex justify-content-center ">{remainingContent()}</div>
                  )}
                </div>
              ) : (
                <>
                  <div className="row justify-content-center align-items-center mt-2">
                    {/* <div className='timer-btn lh-20 text-uppercase '> <span className='fs-30 f-bold  '>{timer.hours}</span><br /> <span className='ml--5px'>Hours</span></div>
                <div className='timer-btn lh-20 text-uppercase' > <span className='fs-30 f-bold '>{timer.minute}</span><br /> <span>Min</span></div> */}
                    <div className="ml-3">{remainingContent()}</div>
                  </div>
                  {_.isEmpty(myProfile) ? (
                    <div className="row justify-content-center alien-item-center mt-4">
                      <div className="d-flex align-items-center">Upgrade Your Account For Additional Appraisals</div>
                      <button
                        type="button"
                        className=" btn-grad-outline btn normal-btn pl-4 pr-4"
                        data-action="appraisal-search"
                        onClick={(e: React.FormEvent) => {
                          e.preventDefault();
                          signUp();
                        }}
                      >
                        Upgrade
                      </button>
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </div>

          {_.isEmpty(appraisalDetails) && !appraisalError ? <AppraisalDashboard handleSubmit={handleSubmit} buyDomain={buyDomain} sendAppraisalToMail={sendAppraisalToMail} /> : <AppraisalResult handleSubmit={handleSubmit} buyDomain={buyDomain} sendAppraisalToMail={sendAppraisalToMail} />}
        </>
      )}
    </>
  );
});

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(Appraisal);
